'use client';

import { ButtonV2 } from '@/app_components/ui/ButtonV2';

interface SurveyProps {
  surveyUrl?: string | null;
}

export const Survey = ({ surveyUrl }: SurveyProps) => {
  if (!surveyUrl) {
    return null;
  }

  return (
    <div
      className='flex flex-col md:flex-row justify-center items-center  py-xs px-sm border info-border relative z-9 w-full rounded info-surface gap-6'
      data-cy='survey-container'
    >
      <div
        className='flex flex-col items-start w-full'
        data-cy='survey-content'
      >
        <h2
          className='text-primary typography-level-5 font-bold font-inria-serif'
          data-cy='survey-heading'
        >
          Your opinion matters!
        </h2>

        <div
          className='text-secondary font-normal typography-default font-graphik-compact'
          data-cy='survey-description'
        >
          Please take a moment to share feedback—we're always looking to improve.
        </div>
      </div>
      <ButtonV2
        className='font-medium typography-sm tracking-none transition-colors w-full md:w-[141px]'
        data-cy='survey-link'
        href={surveyUrl}
        rel='noopener noreferrer'
        size='lg'
        target='_blank'
        variant='primary'
      >
        <span>Take Survey</span>
      </ButtonV2>
    </div>
  );
};
